import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { Link } from 'react-router-dom';

export default function CTA() {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  return (
    <section
      ref={ref}
      className={`relative py-36 overflow-hidden transition-all duration-700 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/62d5dcf4a49ed7bf802f7e1e1d4328cc.jpg"
          alt="Start Your Campaign"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-slate-900/70"></div>
      </div>

      <div className={`relative max-w-4xl mx-auto px-6 text-center transition-all duration-700 delay-200 ${
        isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95'
      }`}>
        <h2 className="text-5xl lg:text-6xl font-bold text-white tracking-wide mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          Let's have a chat...
        </h2>
        <p className="text-xl text-white/90 mb-12 leading-relaxed max-w-2xl mx-auto">
          Let's create a social media strategy with Maria at unuu that puts your brand in front of the right customers and tells your story with clarity.
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center gap-4 px-10 py-5 bg-[#00989e] text-white font-bold rounded-full hover:bg-[#007a7f] transition-all hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
        >
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
            <i className="ri-rocket-2-line text-xl text-[#00989e]"></i>
          </div>
          <span className="uppercase tracking-wide">Book Free Strategy Call</span>
          <i className="ri-arrow-right-up-line text-2xl"></i>
        </Link>
      </div>
    </section>
  );
}
